import { render, staticRenderFns } from "./IconMultiCliente.vue?vue&type=template&id=859c931c&"
import script from "./IconMultiCliente.vue?vue&type=script&lang=ts&"
export * from "./IconMultiCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports